import { render } from "./GetInTouchFormSection.vue?vue&type=template&id=53ae4270&scoped=true"
import script from "./GetInTouchFormSection.vue?vue&type=script&lang=js"
export * from "./GetInTouchFormSection.vue?vue&type=script&lang=js"

import "../../assets/css/contact.css?vue&type=style&index=0&lang=css&external"
import "./GetInTouchFormSection.vue?vue&type=style&index=1&id=53ae4270&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53ae4270"]])

export default __exports__